import { gql } from '@apollo/client';

/**
 * 合并查询：菜单树 + 权限码列表，登录后一次请求
 */
export const GET_PORTAL_AUTH_DATA = gql`
    query GetPortalAuthData {
        portalMenuTree {
            id
            parentId
            permissionCode
            permissionName
            resourcePath
            icon
            sortOrder
            children {
                id
                parentId
                permissionCode
                permissionName
                resourcePath
                icon
                sortOrder
                children {
                    id
                    parentId
                    permissionCode
                    permissionName
                    resourcePath
                    icon
                    sortOrder
                    children {
                        id
                        parentId
                        permissionCode
                        permissionName
                        resourcePath
                        icon
                        sortOrder
                    }
                }
            }
        }
        portalPermissions
    }
`;
